<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Share this file</template>

    <Sheet.Body class="pt-[25px]">
      <ShareBody :file="file" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { File } from '@/shared/graphql/router/graphql'
import ShareBody from './ShareBody.vue'

defineProps<{
  file: File
}>()

const { close } = useSheet()
</script>
